import {
  FETCH_CONTENT_COLLECTION_ENTRY,
  FETCH_CONTENT_COLLECTION_ENTRY_FULFILLED,
  FETCH_CONTENT_COLLECTION_ENTRY_REJECTED,
} from 'b2b-apps/shop/content/redux/contentCollectionsEntries/actionTypes';
import {
  ContentCollectionEntryType,
  FetchContentCollectionEntryAction,
  FetchContentCollectionEntryFulfilledAction,
  FetchContentCollectionEntryRejectedAction,
} from 'b2b-apps/shop/content/redux/contentCollectionsEntries/types';

const fetchContentCollectionEntry = (
  collectionId: string,
  entryId: string,
): FetchContentCollectionEntryAction => ({
  type: FETCH_CONTENT_COLLECTION_ENTRY,
  payload: {
    collectionId,
    entryId,
  },
});

const fetchContentCollectionEntryFulfilled = (
  collectionId: string,
  entryId: string,
  response: ContentCollectionEntryType,
): FetchContentCollectionEntryFulfilledAction => ({
  type: FETCH_CONTENT_COLLECTION_ENTRY_FULFILLED,
  payload: {
    collectionId,
    data: response,
    entryId,
  },
});

const fetchContentCollectionEntryRejected = (
  collectionId: string,
  entryId: string,
  error: ErrorType,
): FetchContentCollectionEntryRejectedAction => ({
  type: FETCH_CONTENT_COLLECTION_ENTRY_REJECTED,
  payload: {
    collectionId,
    entryId,
    error,
  },
});

export {
  fetchContentCollectionEntry,
  fetchContentCollectionEntryFulfilled,
  fetchContentCollectionEntryRejected,
};
